import { render, staticRenderFns } from "./CollaboratorList.vue?vue&type=template&id=192c8c47&scoped=true"
import script from "./CollaboratorList.vue?vue&type=script&lang=js"
export * from "./CollaboratorList.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorList.vue?vue&type=style&index=0&id=192c8c47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c8c47",
  null
  
)

export default component.exports